import { render, staticRenderFns } from "./usercomp.vue?vue&type=template&id=7b134477&scoped=true&"
import script from "./usercomp.vue?vue&type=script&lang=js&"
export * from "./usercomp.vue?vue&type=script&lang=js&"
import style0 from "./usercomp.vue?vue&type=style&index=0&id=7b134477&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b134477",
  null
  
)

export default component.exports